import React from 'react';

export class GlowFrames extends React.Component {
  render(){
      return (
        <div className="w3-card w3-animate-bottom full-project-card" id="glow frames">
          <h1>Glow Frames</h1>
          <p>Use a s-shaped LED strip behind vinyl to make fun glowy logos.</p>
          <p>Brought them to OpenSauce. Below is a picture of me with one of the funniest streamers DougDoug and his logo I made.</p>
          <img src="../assets/framesDougDoug.jpg" alt="Red head man next to lady holding a square picture frame of a bell pepper with eyes."></img>
        </div>
    );
  }
}
